import { type KeenSliderPlugin } from "keen-slider";
import { debounce } from "../../debounce";

export const useKeenAdaptiveHeightPlugin: KeenSliderPlugin = (slider) => {
    function updateHeight() {
        const details = slider.track.details;
        if (!details) {
            return;
        }

        const activeSlide = slider.slides[details.rel];
        if (!activeSlide) {
            return;
        }

        const activeSlideHeight = `${activeSlide.offsetHeight}px`;
        slider.container.style.setProperty("--adaptive-height", activeSlideHeight);
    }

    const handleDebouncedResize = debounce(updateHeight, 100);

    slider.on("created", updateHeight);
    slider.on("slideChanged", updateHeight);
    slider.on("updated", updateHeight);
    slider.on("detailsChanged", updateHeight);
    window.addEventListener("resize", handleDebouncedResize);

    slider.on("destroyed", () => {
        slider.on("created", updateHeight, true);
        slider.on("slideChanged", updateHeight, true);
        slider.on("updated", updateHeight, true);
        slider.on("detailsChanged", updateHeight, true);
        window.removeEventListener("resize", handleDebouncedResize);
    });
};

export default useKeenAdaptiveHeightPlugin;
